(() => {
  if (window.ModalToast) return;

  const ROOT_ID = 'modal-toast-root';
  const VISIBLE_MS = 5000;

  let activeToast = null;
  let hideTimer = null;

  const ensureRoot = () => {
    let root = document.getElementById(ROOT_ID);
    if (!root) {
      root = document.createElement('div');
      root.id = ROOT_ID;
      root.className = 'modal-toast-root';
      root.setAttribute('aria-live', 'polite');
      root.setAttribute('aria-atomic', 'true');
      document.body.appendChild(root);
    }
    return root;
  };

  const clearTimers = () => {
    if (hideTimer) {
      window.clearTimeout(hideTimer);
      hideTimer = null;
    }
  };

  const removeToast = (toast) => {
    if (!toast || !toast.isConnected) return;
    toast.classList.remove('is-visible');
    window.setTimeout(() => {
      if (toast.isConnected) toast.remove();
      if (activeToast === toast) activeToast = null;
    }, 320);
  };

  const dismiss = () => {
    clearTimers();
    if (activeToast) removeToast(activeToast);
  };

  const show = (message, options = {}) => {
    const text = (message || '').trim();
    if (!text) return;

    const sticky = Boolean(options.sticky);
    const duration =
      typeof options.duration === 'number' ? options.duration : VISIBLE_MS;

    clearTimers();

    const root = ensureRoot();
    let toast = activeToast;

    if (toast && toast.isConnected) {
      toast.textContent = text;
      toast.classList.toggle('is-sending', sticky);
      toast.classList.add('is-visible');
    } else {
      toast = document.createElement('div');
      toast.className = 'modal-toast';
      toast.setAttribute('role', 'status');
      toast.textContent = text;
      if (sticky) toast.classList.add('is-sending');
      root.appendChild(toast);
      activeToast = toast;
      requestAnimationFrame(() => toast.classList.add('is-visible'));
    }

    if (!sticky && duration > 0) {
      hideTimer = window.setTimeout(() => {
        removeToast(toast);
      }, duration);
    }
  };

  window.ModalToast = {
    show,
    dismiss,
    showFrom(el, options) {
      if (!el) return;
      const api = window.TpuStorefrontEnquiry;
      const raw = el.textContent;
      let text;
      if (api && typeof api.customerMessage === 'function') {
        text = api.customerMessage(raw, 'success');
      } else {
        text = String(raw || '').trim();
        if (!text || /translation missing/i.test(text)) {
          text =
            "Thanks — we've received your enquiry and will be in touch shortly.";
        }
      }
      show(text, options);
    },
  };
})();
